(function() { window.GUID_c1713420_b00a_4950_8ee4_2648d3a3efa1 = { getGuid: function() { return "c1713420-b00a-4950-8ee4-2648d3a3efa1"; } }; })();
var CS;
(function (CS) {
    class DivisionsPicker {
        Refresh() {
            this.$picker.off("click." + this.PickerId);
            new CS.DivisionsPicker(this.PickerId, this.replaceUrlOnClick);
        }
        constructor(controlId, replaceUrlOnClick) {
            this.PickerId = controlId;
            this.$picker = $("#" + controlId);
            this.$picker.data("instance", this);
            this.replaceUrlOnClick = replaceUrlOnClick;
            this.$picker.offon("click." + controlId, (e) => {
                this.showDrawer($(e.currentTarget), replaceUrlOnClick);
            });
            const isMyBracketsPicker = controlId.includes("brackets-picker-my-brackets");
            const isMyDivisionsPicker = controlId.includes("divisions-picker-my-divisions");
            const isMainMenuBracketsPicker = controlId.includes("brackets-picker-main-menu");
            if (controlId == "brackets-picker") {
                CS.DivisionsPicker.OnItemClick("brackets-picker", (divisionId, customUrl) => {
                    CS.Nav.Go(customUrl, null, CS.Nav.Source.Standard, replaceUrlOnClick);
                });
            }
            else if (isMyBracketsPicker) {
                CS.DivisionsPicker.OnItemClick(controlId, (divisionId, customUrl) => {
                    CS.Nav.Go(customUrl, null, CS.Nav.Source.Standard, replaceUrlOnClick);
                });
            }
            else if (isMyDivisionsPicker) {
                CS.DivisionsPicker.OnItemClick(controlId, (divisionId, customUrl) => {
                    if (divisionId) {
                        const newUrl = customUrl.replace("-999999", divisionId);
                        CS.Nav.Go(newUrl, null, CS.Nav.Source.Standard, replaceUrlOnClick);
                    }
                });
            }
            else if (isMainMenuBracketsPicker) {
                CS.DivisionsPicker.OnItemClick("brackets-picker-main-menu", (divisionId, customUrl) => {
                    CS.Nav.Go(customUrl, null, CS.Nav.Source.Standard, replaceUrlOnClick);
                });
            }
        }
        static ShowDrawerIfNotDivisionSelected(pickerId) {
            let $divisionsPicker = $("#" + pickerId);
            if (!$divisionsPicker.data("selectedids")) {
                console.log(`Triggering click on division picker. PickerId: ${pickerId}`);
                $divisionsPicker.trigger("click");
            }
        }
        static GetInstance(pickerId) {
            return $("#" + pickerId).data("instance");
        }
        static OnItemClick(pickerId, callback) {
            $(() => {
                let $picker = $("#" + pickerId);
                let divisionsPicker = this.GetInstance(pickerId);
                if (divisionsPicker) {
                    divisionsPicker.onItemClickCallback = callback;
                }
            });
        }
        onItemClick($itemClicked) {
            let me = this;
            me.$LastClickedItem = $itemClicked;
            let divId = $itemClicked.attr("id").replace("div-", "");
            let customUrl = me.replaceIdInCustomUrl(divId);
            me.onItemClickCallback(divId, customUrl, me);
        }
        replaceIdInCustomUrl(id) {
            let customUrl = this.$picker.data("customurl");
            customUrl = customUrl.replace("__divid__", id);
            return customUrl;
        }
        showDrawer($picker, replaceUrl) {
            let me = this;
            let url = CS.Url.CSUrl("showdivisionspickerdrawer");
            let data = {
                selectedIds: $picker.data("selectedids"),
                overrideEventId: $picker.data("override-event-id"),
                showFavoriteButton: $picker.data("show-favorite-button"),
            };
            data["includeBrackets"] = $picker.hasClass("brackets-picker");
            console.log(`Showing divisions picker drawer. PickerId: ${me.PickerId}`);
            CS.Controls.Popup.ShowAjaxModal(url, data, function ({ popup, isPopup }) {
                var _a;
                let replaceidincustomurl = (_a = popup[0]) === null || _a === void 0 ? void 0 : _a.replaceidincustomurl;
                if (replaceidincustomurl) {
                    let customUrl = me.replaceIdInCustomUrl(replaceidincustomurl);
                    me.onItemClickCallback(replaceidincustomurl, customUrl, me);
                    CS.Controls.Popup._currentAjaxModalUrl = "";
                    return;
                }
                if (!isPopup) {
                    return;
                }
                me.popup = popup;
                me.popup.$Control.data("picker", $picker);
                CS.Lag("scrollto." + me.PickerId, 500, function () {
                    let $selectedItem = me.popup.$Control.find(".is-selected");
                    if ($selectedItem.length > 0) {
                        let y = $selectedItem.offset().top;
                        let parentTopOffset = me.popup.$Control.height() / 2;
                        let $popupContent = me.popup.$Control.find(".popup-content");
                        $popupContent.scrollTop(y - parentTopOffset);
                    }
                });
                me.popup.$Control.offon("click." + me.PickerId, ".division-item", function (e) {
                    me.popup.Proceed = true;
                    me.popup.Close(replaceUrl);
                    const $itemClicked = $(e.currentTarget);
                    me.onItemClick($itemClicked);
                });
            }, function ({ popup }) {
                if (popup.Proceed) {
                }
            }, true);
        }
    }
    CS.DivisionsPicker = DivisionsPicker;
})(CS || (CS = {}));

//# sourceMappingURL=divisions-picker.js.map
